import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Container, Grid, Link, TextField, CssBaseline, Button, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import useStyles from "components/Auth/Login/Styles";
import useActions from "../actions";
import { checkEmailValid, checkFieldValid, checkLoginPassword } from "components/User/Validation";
import { USER_PROP } from "components/User/constants";
import { AppRouteURI } from "router/RoleBasedAccess";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import ConfirmationDialog from "components/common/ConfirmationDialog"
import { USER_SIGNUP_PROP } from "components/User/constants";

const LoginForm = () => {
  const { login, resendVerification, showToast, setRegistration: setUser, renderVerificationMessage } = useActions();
  const { showResendEmail } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const textfields = [
    USER_SIGNUP_PROP.EMAIL,
    USER_SIGNUP_PROP.FNAME,
    USER_SIGNUP_PROP.LNAME,
    USER_SIGNUP_PROP.AFFILIATION,
    USER_SIGNUP_PROP.HEARABOUTUS,
    USER_SIGNUP_PROP.PASSWORD,
    USER_SIGNUP_PROP.REPEAT_PASSWORD,
  ];
  const [fieldChecked, setFieldChecked] = useState(
    Object.fromEntries(textfields.map((each) => {
      if (each === USER_SIGNUP_PROP.HEARABOUTUS) {
        return [each, true];
      }
      return [[each], false]
    }))
  );
  const [screen, setScreen] = React.useState({
    confirmation: true,
    createAccount: false,
    thankYou: false,
  });
  const classes = useStyles();
  const history = useHistory();

  const submitForm = (event) => {
    event.preventDefault();
    login(email, password);
    renderVerificationMessage(false);
  };

  const componentMount = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const verified = urlParams.get("verified");
    if (verified) {
      showToast("Your email has been verified. You can now login", "success");
    }
  }
  useEffect(componentMount, []);

  // const textfields = [USER_PROP.EMAIL, USER_PROP.PASSWORD];

  const [isFormValid, setIsFormValid] = useState(true);
  const [open, setOpen] = React.useState(false);

  const openHook = () => {
    setFieldChecked(Object.fromEntries(textfields.map((each) => {
      if (each === USER_SIGNUP_PROP.HEARABOUTUS) {
        return [each, true];
      }
      return [[each], false]
    })));
    setTermsChecked(false);
    setPrivacyChecked(false);
  }
  useEffect(openHook, [open]);

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    const checkFields = checkEmailValid(email) && checkLoginPassword(password);
    setIsFormValid(checkFields);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setScreen({
      confirmation: true,
      createAccount: false,
      thankYou: false,
    });
    setTermsChecked(false);
    setPrivacyChecked(false);
    setUser(Object.values(USER_PROP).reduce((acc, each) => ({ ...acc, [each]: '' }), {}));
  };

  // const [, setRegisterOpen] = useState(false);
  // const [disclaimerChecked, setDisclaimerChecked] = useState(false);

  // const handleDisclaimerCheck = () => {
  //   setDisclaimerChecked(!disclaimerChecked);
  // }

  // const dialogClose = () => {
  //   setRegisterOpen(false);
  // };

  const handleResendEmail = () => {
    resendVerification(email);
  }
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container className={classes.loginContainer}>
      <Card className={classes.loginCard}>
        <CardContent>
          <CssBaseline />
          <Grid container>
            <Grid item xs={12} className={classes.loginRow}>
              <Typography component="h1" variant="h5" className={classes.loginTitle}>
                Login to your Account
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <form className={classes.form} onSubmit={submitForm} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  error={
                    fieldChecked[USER_PROP.EMAIL] &&
                    !checkFieldValid(USER_PROP.EMAIL, email)
                  }
                  onClick={() => {
                    setFieldChecked({
                      ...fieldChecked,
                      [USER_PROP.EMAIL]: true,
                    });
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                  autoFocus
                  className={classes.loginRow}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  error={
                    fieldChecked[USER_PROP.PASSWORD] &&
                    !checkFieldValid(USER_PROP.LOGINPASSWORD, password)
                  }
                  onClick={() => {
                    setFieldChecked({
                      ...fieldChecked,
                      [USER_PROP.PASSWORD]: true,
                    });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  className={classes.loginRow}
                />
                <Grid item xs={12} className={classes.loginRow}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    disabled={!isFormValid}
                  >
                    SIGN IN
                  </Button>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignContent="center"
                  direction="column"
                  className={classes.loginRow}
                >
                  {showResendEmail && <Box m={1}>
                    <Typography style={{ color: 'red' }}>
                    {"You have not verified your email. Please check your email for verification link or click "}
                      <Link variant="body2"
                        className={classes.resendLink} 
                        onClick={handleResendEmail}
                      >
                        {"here"}
                      </Link> to resend verification email.
                    </Typography>
                  </Box>}
                  <Box m={1} className={classes.resendLink}>
                    <Link
                      href={AppRouteURI.RESET_PWD}
                      variant="body2"
                      className={classes.loginLink}
                    >
                      Forgot password
                    </Link>
                  </Box>
                  <Box m={1} mb={3} className={classes.loginBox}>
                    <Link
                      variant="body2"
                      className={classes.loginLink}
                      onClick={() => {
                        handleClickOpen(true);
                      }}
                    >
                      -Create an account-
                    </Link>
                  </Box>
                </Grid>

                <Grid container justify="center" alignContent="center" className={classes.loginRow}>
                  <Button
                    variant="contained"
                    className={classes.return}
                    onClick={() => history.push(AppRouteURI.HOME)}
                  >
                    Return to Main Page
                  </Button>
                </Grid>
              </form>
              <ConfirmationDialog 
                open={open}
                handleClose={handleClose}
                screen={screen}
                setScreen={setScreen} 
                fieldChecked={fieldChecked}
                setFieldChecked={setFieldChecked}
                termsChecked={termsChecked}
                setTermsChecked={setTermsChecked}
                privacyChecked={privacyChecked}
                setPrivacyChecked={setPrivacyChecked}
                // signupFieldChecked={signupFieldChecked}
                // setSignupFieldChecked={setSignupFieldChecked}
              />
              {/* <Dialog onClose={dialogClose} aria-labelledby="register-disclaimer-title" open={registerOpen} maxWidth={"md"} classes={{ paper: classes.dialogPaper }}>
                <DialogTitle id="register-disclaimer-title">
                  <Typography component="h1" variant="h5" className={classes.registerDialogTitle}>
                    Creating an Account - TEST
                  </Typography>
                  <IconButton aria-label="close" className={classes.closeButton} onClick={dialogClose}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Typography gutterBottom>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut consequat semper viverra nam libero. Feugiat in fermentum posuere urna. Nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. Lacus sed turpis tincidunt id aliquet risus feugiat in. Nisl condimentum id venenatis a condimentum vitae sapien pellentesque. Lacus sed turpis tincidunt id aliquet risus feugiat in. Sed tempus urna et pharetra pharetra massa massa ultricies mi. Blandit massa enim nec dui nunc mattis enim ut. Velit scelerisque in dictum non consectetur. Eget dolor morbi non arcu. Laoreet sit amet cursus sit. Ut etiam sit amet nisl purus.
                  </Typography>
                  <Typography gutterBottom>
                    In nisl nisi scelerisque eu ultrices vitae auctor eu augue. Arcu non sodales neque sodales. Et magnis dis parturient montes nascetur. Malesuada bibendum arcu vitae elementum curabitur vitae nunc sed velit. Quisque id diam vel quam elementum. Consectetur adipiscing elit duis tristique sollicitudin nibh. Auctor neque vitae tempus quam. Vulputate odio ut enim blandit. Enim tortor at auctor urna nunc id cursus. Augue ut lectus arcu bibendum at varius. Purus ut faucibus pulvinar elementum integer enim neque volutpat ac.
                  </Typography>
                  <FormControlLabel className={classes.registerDisclaimerContainer} control={
                    <Checkbox name="disclaimerCheckbox" checked={disclaimerChecked} onChange={handleDisclaimerCheck} />
                    } label={(
                      <Typography gutterBottom>
                        I understand
                      </Typography>
                    )} />
                </DialogContent>
                <DialogActions>
                  <Container className={classes.dialogActionsContainer}>
                    <Button variant="contained" color="primary" onClick={() => history.push(AppRouteURI.REGISTER)} 
                      className={classes.confirmButton} disabled={!disclaimerChecked}>
                      Confirm
                    </Button>
                    <Button onClick={dialogClose} variant="outlined">
                      Cancel
                    </Button>
                  </Container>
                </DialogActions>
              </Dialog> */}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default LoginForm;
